module.exports = __webpack_public_path__ + "img/charger-speeds-mobile@2x.fa7c916e.png";